module.exports = __webpack_public_path__ + "images/presentation-1-7000f297b5fe0a56232eedb2637ad583.jpg";